// ── Favourites ────────────────────────────────────────────────────────────────
// profiles.favorite_shows is a small JSON list of {id, name, poster_path} shown on the
// public profile as "All-Time Favorites". Until 17 only the TV Time import wrote it;
// this is the toggle the show page's More sheet uses. Max 8, newest last.
import { supabase } from './supabase'

export const MAX_FAVORITES = 8

export async function readFavorites() {
  try {
    const { data } = await supabase.rpc('get_my_profile').maybeSingle()
    return Array.isArray(data?.favorite_shows) ? data.favorite_shows : []
  } catch { return [] }
}

export function isFavorite(list, showId) {
  return (list || []).some(f => Number(f.id) === Number(showId))
}

// Returns { list, added, full } — `full` when the cap stopped an add.
export async function toggleFavorite(userId, show) {
  if (!userId || !show?.id) return { list: [], added: false, full: false }
  const list = await readFavorites()
  const on = isFavorite(list, show.id)
  let next
  if (on) next = list.filter(f => Number(f.id) !== Number(show.id))
  else {
    if (list.length >= MAX_FAVORITES) return { list, added: false, full: true }
    next = [...list, { id: show.id, name: show.name, poster_path: show.poster_path || null }]
  }
  const { error } = await supabase.from('profiles').update({ favorite_shows: next }).eq('id', userId)
  if (error) return { list, added: on, full: false, error }
  return { list: next, added: !on, full: false }
}
